/**
 * Behaviour names compared the way people read them: case- and whitespace-
 * insensitive ("Screaming", " screaming ", "SCREAMING" are the same behaviour).
 * The server applies the same rule when an IEP is saved (iep.py
 * _assert_no_new_duplicate_behaviors).
 */
export const behaviorNameKey = (name) =>
  String(name || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();

/**
 * The existing behaviour a new / renamed one would clash with, or null.
 * `behaviors` are the child's current behaviours; `exceptIndex` is the one being
 * edited (it may keep its own name).
 */
export const findDuplicateBehavior = (name, behaviors, exceptIndex = null) => {
  const key = behaviorNameKey(name);
  if (!key) return null;
  return (behaviors || []).find((b, i) => i !== exceptIndex && behaviorNameKey(b?.behaviorName || b?.name) === key) || null;
};

/** Names of the other behaviours (all but `exceptIndex`) - for the editor's live check. */
export const otherBehaviorNames = (behaviors, exceptIndex = null) =>
  (behaviors || [])
    .filter((_, i) => i !== exceptIndex)
    .map((b) => b?.behaviorName || b?.name || '')
    .filter(Boolean);
